// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ImageCanvas {\n  width: 0;\n  height: 0;\n  overflow: hidden;\n  display: inline-block;\n}\n", ""]);
// Exports
module.exports = exports;
